// @flow
import { styled } from 'mz-ui-kit'
import type { BaseStyles } from '.'
import * as materialAppearance from './appearance/material'
import * as mobileSearchAppearance from './appearance/mobile-search'
import * as materialWoBaselineAppearance from './appearance/material-wo-baseline'
import * as rectAppearance from './appearance/rect'
import * as compactAppearance from './appearance/compact'
import * as btpFieldAppearance from './appearance/btp-field'
import * as btpFieldOutlinedAppearance from './appearance/btp-field-outlined'
import * as hertzAppearance from './appearance/hertz'
import { getAppearanceFunc } from '../../utils'

// Constants
const BASE_CLASS = 'base-field'
const APPEARANCES = {
  material: materialAppearance,
  'mobile-search': mobileSearchAppearance,
  'material-wo-baseline': materialWoBaselineAppearance,
  rect: rectAppearance,
  compact: compactAppearance,
  'btp-field': btpFieldAppearance,
  'btp-field-outlined': btpFieldOutlinedAppearance,
  hertz: hertzAppearance,
}

const createAppearanceFunc = getAppearanceFunc(APPEARANCES, 'material')

// Container for the input
export const Container = styled<BaseStyles>(
  {
    base: 'label',
    mozClassName: ({ $appearance }) => [
      BASE_CLASS,
      `${BASE_CLASS}--${$appearance}`,
    ],
  },
  createAppearanceFunc('Container')
)

// The line above the input
export const Baseline = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__baseline`,
  },
  createAppearanceFunc('Baseline')
)

// The input element
export const InputWrapper = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__input`,
  },
  createAppearanceFunc('InputWrapper')
)

// A small wrapper around content - input and label
export const Content = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__content`,
  },
  createAppearanceFunc('Content')
)

// Float label element
export const Label = styled<BaseStyles>(
  {
    base: 'span',
    mozClassName: `${BASE_CLASS}__label`,
  },
  createAppearanceFunc('Label')
)

// A row input and control buttons
export const InputWithControls = styled<BaseStyles>(
  'div',
  createAppearanceFunc('InputWithControls')
)

// Errors container
export const Errors = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__errors`,
  },
  createAppearanceFunc('Errors')
)

// Container for loading spinner to show/hide it with animation
export const LoadingContainer = styled<BaseStyles>(
  'div',
  createAppearanceFunc('LoadingContainer')
)

// Button to clear the input
export const ClearButton = styled<BaseStyles>(
  'div',
  createAppearanceFunc('ClearButton')
)

// Button for selectable fields
export const ArrowButton = styled<BaseStyles>(
  'div',
  createAppearanceFunc('ArrowButton')
)

// Wrapper for the content before the input
export const PrefixWrapper = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__prefix`,
  },
  createAppearanceFunc('PrefixWrapper')
)

// Wrapper for the content after the input
export const PostfixWrapper = styled<BaseStyles>(
  {
    base: 'div',
    mozClassName: `${BASE_CLASS}__postfix`,
  },
  createAppearanceFunc('PostfixWrapper')
)
